import { focusReview } from '../../shared/focus';
import type { LocalRecord, Task } from '../../shared/model';
import { isAvailableRecord } from '../../shared/trash';

export type TaskFilter = 'active' | 'completed' | 'dropped' | 'all' | 'review';

export const taskPageSize = 25;

export function taskListPage(
  records: LocalRecord[],
  filter: TaskFilter,
  search: string,
  page: number,
) {
  const query = search.trim().toLocaleLowerCase();
  const reviewTasks = filter === 'review' ? focusReview(records).taskIds : new Set<string>();

  const matching = records
    .filter(record => {
      if (record.kind !== 'task' || !isAvailableRecord(record)) {
        return false;
      }

      const task = record.value as Task;

      const statusMatches =
        filter === 'all' ||
        (filter === 'review'
          ? reviewTasks.has(record.id)
          : filter === 'completed'
            ? task.done
            : filter === 'dropped'
              ? !task.done && task.dropped
              : !task.done && !task.dropped);

      return statusMatches && task.title.toLocaleLowerCase().includes(query);
    })
    // Most recently created or changed first. Records carry no creation time, and
    // creating a task is its first change, so `updatedAt` covers both.
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt) || a.id.localeCompare(b.id));

  const pages = Math.max(1, Math.ceil(matching.length / taskPageSize));
  const currentPage = Math.min(Math.max(1, page), pages);

  return {
    rows: matching.slice((currentPage - 1) * taskPageSize, currentPage * taskPageSize),
    total: matching.length,
    pages,
    page: currentPage,
  };
}
